import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkTextInput } from 'uitk-react-input';

const TrackedTextInput = ClickTracker(UitkTextInput);

export const ReviewsDialogInput = ({ listClasses, l10n, onFocus }) => (
  <div className={listClasses}>
    <div className=".uitk-grid.all-cell-1-1">
      <TrackedTextInput
        onFocus={onFocus}
        value=""
        label={l10n.formatText('hotels.infosite.findAnswers.cta.reviews.placeholder')}
        placeholder={l10n.formatText('hotels.infosite.findAnswers.cta.reviews.placeholder')}
        id="findAnswerReviewEntry"
        icon="search"
        name="findAnswerReviewEntry"
        hasVisibleLabel={false}
        linkName="Open from ReviewEntry"
        rfrr="AskQuestion.FindAnswersReviewEntry"
      />
    </div>
  </div>
);

ReviewsDialogInput.displayName = 'ReviewEntry';
